<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-solid fa-file-signature" />&nbsp;{{ $t('contracts') }}
        </template>

        <ContractsTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@src/partials/pages/PageWrapper.vue'
import ContractsTable from '@src/partials/contracts/ContractsTable.vue'
</script>
